import { IconChevronChevronRight } from '@doltech/icons/IconChevronChevronRight';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import * as React from 'react';
import { TooltipRenderProps } from 'react-joyride';
import styled from 'styled-components';

const DESKTOP_WIDTH = 301;

const TooltipBody = styled.div`
  background-color: ${colorsV2.white100};
  padding: 16px;
  width: ${DESKTOP_WIDTH}px;
  border-radius: 8px;
  .row {
    display: flex;
    align-items: center;
  }

  .guided-footer {
    margin-top: 8px;

    .dot-navigation {
      flex: 1;
      display: flex;
      align-items: center;
      .dot {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: ${colorsV2.gray40};
        margin-right: 4px;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          background-color: ${colorsV2.gray100};
        }
      }
    }
    .btn-actions {
      justify-content: flex-end;
      button {
        min-width: 80px;
        margin-right: 8px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .opt-out {
      color: ${colorsV2.gray100};
      text-align: right;
      margin-top: 8px;
      .em {
        font-weight: 500;
        cursor: pointer;
        color: ${colorsV2.primary100};
      }
    }
  }
`;

export const GuidedTourTooltip = (props: TooltipRenderProps) => {
  const { continuous, index, step, primaryProps, tooltipProps, size } = props;
  const isNotLastStep = index < size - 1;
  return (
    <TooltipBody {...tooltipProps}>
      <div className="guided-content">
        <Typography.Text variant="regular/14">{step.content}</Typography.Text>
      </div>
      <div className="guided-footer">
        <div className="btn-actions row">
          {continuous && (
            <Button.Secondary
              iconRight={isNotLastStep ? <IconChevronChevronRight /> : undefined}
              variant="dark"
              size="large"
              {...primaryProps}
            >
              {isNotLastStep ? 'Next' : 'Done'}
            </Button.Secondary>
          )}
        </div>
      </div>
    </TooltipBody>
  );
};
